import { jsx as _jsx } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { Link } from "../../../link/src";
import { baseLinkStyles, ItemComponent } from './ItemComponent';
export const SubMenuItem = ({ handleShowSubMenu, isMobile, itemIndex, menuItemRef, subItem, }) => {
    var _a;
    const isSubMenuItemIsActive = typeof window === 'undefined'
        ? false
        : subItem.path === ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname);
    const handleClick = (event) => {
        event.stopPropagation();
        handleShowSubMenu(false);
    };
    const handleSubItemKeyDown = (event, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        event.stopPropagation();
        switch (event.key) {
            case 'ArrowUp': {
                event.preventDefault();
                if (index === 0) {
                    (_b = (_a = menuItemRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('a')) === null || _b === void 0 ? void 0 : _b.focus();
                    handleShowSubMenu(false);
                }
                else {
                    const prevLink = (_d = (_c = event.currentTarget
                        .closest('li')) === null || _c === void 0 ? void 0 : _c.previousElementSibling) === null || _d === void 0 ? void 0 : _d.querySelector('a');
                    prevLink === null || prevLink === void 0 ? void 0 : prevLink.focus();
                }
                break;
            }
            case 'ArrowDown': {
                event.preventDefault();
                const nextLink = (_f = (_e = event.currentTarget
                    .closest('li')) === null || _e === void 0 ? void 0 : _e.nextElementSibling) === null || _f === void 0 ? void 0 : _f.querySelector('a');
                if (nextLink) {
                    nextLink.focus();
                }
                break;
            }
            case 'Tab': {
                event.preventDefault();
                handleShowSubMenu(false);
                if (event.shiftKey) {
                    (_j = (_h = (_g = menuItemRef.current) === null || _g === void 0 ? void 0 : _g.previousElementSibling) === null || _h === void 0 ? void 0 : _h.querySelector('a')) === null || _j === void 0 ? void 0 : _j.focus();
                }
                else {
                    (_m = (_l = (_k = menuItemRef.current) === null || _k === void 0 ? void 0 : _k.nextElementSibling) === null || _l === void 0 ? void 0 : _l.querySelector('a')) === null || _m === void 0 ? void 0 : _m.focus();
                }
                break;
            }
            case 'Escape':
                event.preventDefault();
                handleShowSubMenu(false);
                (_p = (_o = menuItemRef.current) === null || _o === void 0 ? void 0 : _o.querySelector('a')) === null || _p === void 0 ? void 0 : _p.focus();
                break;
        }
    };
    return (_jsx(ItemComponent, { "$active": isSubMenuItemIsActive, "$isMobileMenuItem": subItem.isMobileMenuItem, "aria-selected": isSubMenuItemIsActive, as: "li", role: "menuitem", tabIndex: -1, children: _jsx(LinkStyled, { "$active": isSubMenuItemIsActive, "$isMobile": isMobile, "$isMobileMenuItem": subItem.isMobileMenuItem, forceDefaultLink: subItem.forceDefaultLink, onClick: handleClick, onKeyDown: (evt) => handleSubItemKeyDown(evt, itemIndex), styledOnlyOnHover: true, target: subItem.target, to: subItem.path, children: subItem.label }) }, subItem.key));
};
const LinkStyled = styled(Link) `
  ${baseLinkStyles}

  &:hover {
    font-weight: normal !important;
  }

  ${({ $isMobile, $isMobileMenuItem }) => $isMobile &&
    !$isMobileMenuItem &&
    css `
      margin-left: 12px;
    `}
`;
//# sourceMappingURL=SubMenuItem.js.map